"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAnswer = updateAnswer;
const computedAnswers_1 = require("./computedAnswers");
const effects_1 = require("./effects");
const formatAnswers_1 = require("./formatAnswers");
const filterVisibleAnswers_1 = require("./nodeEvaluation/visibleIf/filterVisibleAnswers");
const defaultAnswers_1 = require("./defaultAnswers");
function updateAnswer(questionnaire, answersResolver, dependencyMap, item, timezone, currentDateOverride, applicationContext = {}) {
    (0, effects_1.processSetValueEffects)(item.effects?.beforeValueUpdate, item.value, answersResolver, dependencyMap, item.nodeIdScope, // Effects use nodeId because they use conditions.
    timezone, applicationContext, currentDateOverride);
    if (item.value === undefined) {
        if (item.tag === 'blueprintId') {
            answersResolver.unsetAnswer(item.blueprintId, item.blueprintIdScope);
        }
        else {
            answersResolver.usingNodeId().unsetAnswer(item.nodeId, item.nodeIdScope);
        }
    }
    else {
        if (item.tag === 'blueprintId') {
            answersResolver.setAnswer(item.value, item.blueprintId, item.blueprintIdScope);
        }
        else {
            answersResolver.usingNodeId().setAnswer(item.value, item.nodeId, item.nodeIdScope);
        }
    }
    (0, formatAnswers_1.formatAnswers)(questionnaire, answersResolver);
    // Changing this answer could affect the visibility of other answers.
    if (item.nodeId) {
        (0, filterVisibleAnswers_1.filterVisibleAnswers)(item.nodeId, dependencyMap, answersResolver, item.nodeIdScope, timezone, currentDateOverride);
    }
    (0, effects_1.processSetValueEffects)(item.effects?.afterValueUpdate, item.value, answersResolver, dependencyMap, item.nodeIdScope, timezone, applicationContext, currentDateOverride);
    (0, defaultAnswers_1.defaultQuestionnaireAnswers)(questionnaire, answersResolver, dependencyMap, timezone, currentDateOverride);
    (0, computedAnswers_1.computedQuestionnaireAnswers)(questionnaire, answersResolver, dependencyMap, timezone, currentDateOverride);
}
